<template>
  <line-chart
    style="position: relative; height:350px"
    :data="this.getLineChartData"
    :options="this.lineChartOptions"
    v-if="this.getLineChartData"
  ></line-chart>
</template>

<script>
  import moment from "moment";
  import LineChart from "../Wrappers/lineChart";

  let width, height, gradient;

  const gradientColors = ['red', 'darkorange', 'green'];
  const labels = ['Good', 'Average', 'Low'];

  export default {
    name: "TrendLineCompany",
    components: {LineChart},
    props: ['companyAvg', 'gradientColors', 'labels'],
    data() {
      return {
        lineChartOptions: {
          radius: 0,
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: 'top'
          },
          tooltip: {
            enabled: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
            }],
            yAxes: [
              {
                id: 'A',
                position: 'right',
                gridLines: {
                  display: false
                },
                ticks: {
                  suggestedMax: 2,
                  suggestedMin: 0
                },
                display: false
              },
              {
                id: 'C',
                type: 'category',
                position: 'left',
                gridLines: {
                  display: false
                },
                labels: this.labels ? this.labels : labels,
                display: true
              }]
          },
        }
      }
    },
    methods: {
      getGradient(ctx, chartArea) {
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (gradient === null || width !== chartWidth || height !== chartHeight) {
          // Create the gradient because this is either the first render
          // or the size of the chart has changed
          width = chartWidth;
          height = chartHeight;
          gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, this.defaultGradientColors()[0]);
          gradient.addColorStop(0.5, this.defaultGradientColors()[1]);
          gradient.addColorStop(1, this.defaultGradientColors()[2]);
        }

        return gradient;
      },
      defaultGradientColors() {
        return this.gradientColors ? this.gradientColors : gradientColors;
      },
      defaultLabels() {
        return this.labels ? this.labels : labels;
      }
    },
    computed: {
      getLineChartData() {
        let datasets = [];
        let labels = [];
        if (this.companyAvg) {
          const data = [...this.companyAvg]
          datasets.push({
            label: 'Company average',
            lineTension: 0.4,
            pointRadius: 0,
            fill: false,
            // backgroundColor: '#c4c7fc',
            // borderColor: '#9c9cd1',
            borderColor: (context) => {
              const chart = context.chart;
              const {ctx, chartArea} = chart;

              if (!chartArea) {
                // This case happens on initial chart load
                return null;
              }
              return this.getGradient(ctx, chartArea);
            },
            yAxisID: 'A',
            data: [...data].map(e => 2 - Math.round((e.averageEngagement) * 100) / 100).reverse().slice(-20)
          })
          labels = [...data].map(e => moment().day('Monday').week(e.week).year(e.year).format('DD-MMM-YYYY'))
            .sort((a, b) => b - a)
            .reverse()
            .slice(-20)
        }
        return {labels, datasets};
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/dashboard/TrendLineCompany.vue